/**
 * Configuration
 * @type {Object}
 */
let config = { debug: true, excludes: [] }

let standardEvents = [
    "addpaymentinfo", "addtocart", "addtowishlist",
    "completeregistration", "contact", "customizeproduct",
    "donate", "findlocation", "initiatecheckout", "lead",
    "pageview", "purchase",
    "schedule", "search", "starttrial", "submitapplication", "subscribe",
    "viewcontent"
];

// Private functions

const _fbqEnabled = () => {
    if (typeof window.fbq === "undefined") {
        if (config.debug) console.log( "[Vue Facebook Pixel]: `window.fbq` is not defined, skipping" );
        return false;
    }

    return true;
};

// Public functions

/**
 * Init facebook tracking pixel
 * @param  {String} appId
 * @param  {object} [data={}]
 */
const init = (appId, data = {}) => {
    if (!_fbqEnabled()) return;
    if (config.debug) console.log( `[Vue Facebook Pixel] Initializing app ${appId}` );
    query('init', appId, data);
}

/**
 * Event tracking
 * @param  {String} name
 * @param  {object} [data={}]
 */
const event = (name, data = {}) => {
    if (!_fbqEnabled()) return;

    if (config.debug) {
        console.groupCollapsed( `[Vue Facebook Pixel] Track event "${name}"` );
        console.log(`With data: ${data}`);
        console.groupEnd();
    }

    if (!standardEvents.includes(name.toLowerCase())) query("trackCustom", name, data);
    else query("track", name, data);
};

/**
 * Submit a raw query to fbq, for when the wrapper limits user on what they need.
 * This makes it still possible to access the plain Analytics api.
 * @param mixed ...args
 */
const query = (...args) => {
    if (!_fbqEnabled()) return;
    if (document.location.pathname.match(/bookings_dev-mode/)) return;

    if (config.debug) {
        console.groupCollapsed( `[Vue Facebook Pixel] Raw query` );
        console.log(`With data: `, ...args);
        console.groupEnd();
    }

    window.fbq(...args);
}

/**
 * Vue installer
 * @param  {Vue instance} Vue
 * @param  {Object} [options={}]
 */
const install = (Vue, options = {}) => {
    // console.log(`fb-pixel.install`);

    const { debug, excludeRoutes } = options;
    // const { router, debug, excludeRoutes } = options;

    config.excludes = excludeRoutes || config.excludes;
    config.debug = !!debug;

    if (!Vue.analytics) Vue.analytics = {};
    if (!Vue.prototype.$analytics) Vue.prototype.$analytics = {};

    Vue.analytics.fbq = { init, event, query };
    Vue.prototype.$analytics.fbq = { init, event, query };

    // if (router) {
    //     const { excludes } = config;

    //     router.afterEach(({ name }) => {
    //         if (excludes.length && excludes.indexOf(name) !== -1) return;
    //         Vue.analytics.fbq.event("PageView");
    //     })
    // }
}

export default { install };
